// in src/User.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  ImageInput,
  required,
  List,
  Show,
  Create,
  Edit,
  Filter,
  BooleanField,
  ReferenceField,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  FormTab,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  TabbedForm,
  DateField,
  ChipField,
  ImageField,
  NumberField,
  NumberInput,
  FileInput,
  ArrayInput,
  FileField,
  SimpleFormIterator,
  ArrayField,
} from "react-admin";

import { DateInput } from "./components/pickers";

import UrlRef from "./UrlRef";

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="title" alwaysOn />
  </Filter>
);

const EntryTitle = ({ record }) => {
  return <span>{record ? `${record.firstname} ${record.lastname}` : ""}</span>;
};

export const UserList = (props) => (
  <List
    {...props}
    filters={<UserFilter />}
    exporter={false}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField source="firstname" label="First Name" />
      <TextField source="lastname" label="Last Name" />
      <BooleanField source="isPublished" label="Published" />
      <NumberField source="priority" />
      <BooleanField source="isAdmin" />

      <ReferenceField
        label="Position"
        source="position"
        reference="positions"
        linkType={false}
      >
        <ChipField source="description" />
      </ReferenceField>
      <ShowButton label="" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

export const UserShow = (props) => {
  return (
    <Show {...props} title={<EntryTitle />}>
      <TabbedForm redirect={false}>
        <FormTab label="Identity">
          <TextField source="email" label="Email" />

          <ImageField
            label="Profile Picture"
            source="photo.src"
            title="photo.title"
          />
          <TextField source="firstname" label="Firstname" />
          <TextField source="lastname" label="Lastname" />
          <BooleanField source="isAdmin" label="Admin" />
          <BooleanField source="isPublished" label="Published" />
        </FormTab>
        <FormTab label="Details">
          <ReferenceField
            label="Position"
            source="position"
            reference="positions"
            linkType={false}
          >
            <ChipField source="description" />
          </ReferenceField>
          <UrlRef label="Linkedin" source="linkedin" />
          <NumberField source="priority" />
        </FormTab>
        <FormTab label="Docs">
          <ArrayField source="docs" label="Docs">
            <Datagrid style={{ width: "100%" }}>
              <DateField label="Date" source="date" locales="lt" />
              <TextField label="Description" source="description" />
              <FileField
                label="Doc"
                source="file.src"
                title="file.title"
                target="_blank"
              />
            </Datagrid>
          </ArrayField>
        </FormTab>
        <FormTab label="Vacations">
          <ArrayField source="vacations" label="">
            <Datagrid style={{ width: "100%" }}>
              <DateField source="dateStart" label="Start Date" locales="lt" />
              <DateField source="dateEnd" label="End Date" locales="lt" />
              <TextField label="Notes" source="notes" />
            </Datagrid>
          </ArrayField>
        </FormTab>
        <FormTab label="Status">
          <TextField source="comments" />
          <DateField
            label="Create Date"
            source="createdate"
            locales="lt"
            showTime
          />
          <DateField
            label="Last Update"
            source="lastupdate"
            locales="lt"
            showTime
          />
        </FormTab>
      </TabbedForm>
    </Show>
  );
};

export const UserCreate = (props) => (
  <Create {...props}>
    <TabbedForm redirect={false}>
      <FormTab label="Identity">
        <TextInput source="email" label="Email" />
        <ImageInput
          source="photo"
          placeholder={<p>Put here the photo</p>}
          validate={required()}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
        <TextInput source="firstname" label="Firstname" />
        <TextInput source="lastname" label="Lastname" />
        <BooleanInput source="isAdmin" />
        <BooleanInput source="isPublished" label="Published" />
      </FormTab>
      <FormTab label="Details">
        <ReferenceInput
          label="Positions"
          source="position"
          reference="positions"
        >
          <SelectInput optionText="description" />
        </ReferenceInput>
        <TextInput source="linkedin" label="Linkedin" />
        <NumberInput source="priority" />
      </FormTab>
      <FormTab label="Status">
        <TextInput source="comments" />
      </FormTab>
    </TabbedForm>
  </Create>
);

export const UserEdit = (props) => {
  return (
    <Edit {...props} title={<EntryTitle />}>
      <TabbedForm redirect={false}>
        <FormTab label="Identity">
          <TextInput source="email" label="Email" />
          <ImageInput
            source="photo"
            placeholder={<p>Put here the photo</p>}
            validate={required()}
          >
            <ImageField source="src" title="title" />
          </ImageInput>
          <TextInput source="firstname" label="Firstname" />
          <TextInput source="lastname" label="Lastname" />
          <BooleanInput source="isAdmin" />
          <BooleanInput source="isPublished" label="Published" />
        </FormTab>
        <FormTab label="Details">
          <ReferenceInput
            label="Positions"
            source="position"
            reference="positions"
          >
            <SelectInput optionText="description" />
          </ReferenceInput>
          <TextInput source="linkedin" label="Linkedin" />
          <NumberInput source="priority" />
        </FormTab>
        <FormTab label="Docs">
          <ArrayInput source="docs" label="">
            <SimpleFormIterator>
              <FileInput
                label=""
                source="file"
                placeholder={<p>Put here the doc</p>}
              >
                <FileField
                  validate={required()}
                  label="doc"
                  source="src"
                  title="title"
                />
              </FileInput>
              <TextInput
                validate={required()}
                source="description"
                label="Description"
              />
              <DateInput
                validate={required()}
                source="date"
                label="Date"
                options={{ format: "dd/MM/yyyy" }}
              ></DateInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
        <FormTab label="Vacations">
          <ArrayField source="vacations" label="">
            <Datagrid style={{ width: "100%" }}>
              <DateField source="dateStart" label="Start Date" locales="lt" />
              <DateField source="dateEnd" label="End Date" locales="lt" />
              <TextField label="Notes" source="notes" />
            </Datagrid>
          </ArrayField>
        </FormTab>
        <FormTab label="Status">
          <TextInput source="comments" />
          <DateField
            label="Create Date"
            source="createdate"
            locales="lt"
            showTime
          />
          <DateField
            label="Last Update"
            source="lastupdate"
            locales="lt"
            showTime
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/users.js